import { client } from '@/common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationSimDeleteAlertReceivers = (onSuccess, onError) => {
    return {
        mutationFn: ({ organizationId, emails }) => {
            return client.delete(replaceParameters(ORGANIZATION.SIM_ALERTS_RECEIVERS.url, { uuid: organizationId }), { data: emails });
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationSimDeleteAlertReceivers;